import {writable} from 'svelte/store';
import Config from '../Models/Config';
import Session from './Session';
import Conference from './Conference';
import Notification from './Notification';
import Helper from '../Models/Helper';

const content = {connection: false, connectionTries: 0, forceClose: false};
let socket = writable(content);


socket.send = (method, url, data) => {
	try {
		const connection = content.connection;
		const body = {method, uri: url};
		let params = {token: Session.getToken()};
		if(Helper.is(data))
			params = Object.assign(data, params);

		body.params = params;

		connection.send(JSON.stringify(body));
	} catch (error) {
		console.error(error);
	}
}

socket.close = () => {
	console.log(content.connection);
	content.forceClose = true;
	socket.set(content);
	content.connection.close();
}

socket.init = () => {
	const token = Session.getToken();
	const websocket = new WebSocket(Config.websocket.endpoint);
	websocket.onopen = (event) => {
		websocket.send(JSON.stringify({method: 'post', uri: '/agent/websocket/register', params: {token}}));
		content.connectionTries = 0;
		content.connection = websocket;
		content.forceClose = false;
		socket.set(content);
		Notification.clear();
	};

	websocket.onmessage = (event) => {
		const data = JSON.parse(event.data);
		const type = data.type;

		switch (type) {
			case 'conference-event':
				Conference.setEvents(data);
				break;
			case 'conference-participants':
				Conference.setParticipants(data);
				break;
			case 'conference-list':
				Conference.setList(data?.conferences);
				break;
			case 'set-conference-data':
				Conference.setData(data?.conferenceId, data?.conferenceSid, data?.conferenceName, data?.duration);
				break;
			case 'incoming':
				Notification.add('incoming', data);
				break;
			case 'incoming-forward':
				Notification.add('incoming-forward', data);
				break;
			case 'cancel-forward':
				Notification.remove('incoming', data.conferenceName);
				break;
			case 'incoming-agent':
				Notification.add('incoming-agent', data);
				break;
			case 'answered':
				Notification.removeIncoming(data);
				break;
			case 'unanswered':
				Notification.removeIncoming(data);
				break;
			default:
				break;
		}
	};
	websocket.onerror = (error) => {
		console.error(error);
	}

	websocket.onclose = () => {
		// if(content.connectionTries < 5) {
			if(!content.forceClose)
				setTimeout(() => {
					socket.init();
				}, 2500);
		// }
		// content.connectionTries++;
		// socket.set(content);
	}

}

export default socket;